import React from 'react';
import { TooltipWrapper, TooltipTriangle, TooltipTriangleBorder } from './components';

const CustomTooltip = ({ below, children, ...rest }) => {
  return (
    <TooltipWrapper className="wit_tooltip" below={below} {...rest}>
      <TooltipTriangleBorder below={below} />
      <TooltipTriangle below={below} />
      {children}
    </TooltipWrapper>
  );
};

export default CustomTooltip;
